import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, message, Divider, Table, Input, Tooltip, Space, Tag } from "antd";
import {
  SearchOutlined,
  AuditOutlined,
  FormOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../components/headerPage";
import { HeaderTitle } from "../../components/headerTitle";
import { useNavigate } from "react-router-dom";
import http from "../../services/http";
import dayjs from "dayjs";

export const PdiColaborador = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  // ID ALTERAÇÃO
  const [search, setSearch] = useState("");

  useEffect(() => {
    listarPdis();
  }, []);

  // LISTAR
  const listarPdis = async () => {
    setLoading(true);
    const api = await http("get", `v1/pdi/listar_ativos_colaborador`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      dataIndex: "descricao",
      title: "Descrição",
      sorter: (a, b) => a.descricao?.localeCompare(b.descricao),
    },
    {
      dataIndex: "status_competencias",
      title: "Situação",
      render: (_, e) =>
        e.status_competencias === 1 ? <Tag color="green">Concluído</Tag> : <Tag color="red">Pendente</Tag>,
      sorter: (a, b) => a.status_competencias?.toString()?.localeCompare(b.status_competencias?.toString()),
    },
    {
      key: "data_criacao",
      title: "Data",
      render: (_, e) => dayjs(e.data_criacao).format("DD/MM/YYYY"),
      sorter: (a, b) =>
        dayjs(a.data_criacao)
          .format("DD/MM/YYYY")
          ?.toString()
          ?.localeCompare(dayjs(b.data_criacao).format("DD/MM/YYYY")),
    },
    {
      dataIndex: "qtd_competencias",
      title: "Nº Comp.",
      width: 100,
      sorter: (a, b) => a.qtd_competencias?.toString()?.localeCompare(b.qtd_competencias?.toString()),
    },
  ];

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter(
      (val) =>
        val.descricao?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        dayjs(val.data_criacao).format("DD/MM/YYYY")?.toLowerCase().includes(pesquisar.toLowerCase())
    );
    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="PDI" onClickBack={() => navigate("/")} />
            <HeaderTitle
              title="Meus PDIs"
              loading={loading}
              subtitle="Lançamentos dos meus PDIs"
              icon={<AuditOutlined />}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
              </Space>

              <Divider />

              <Table
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
                expandRowByClick
                rowKey="id"
                expandable={{
                  expandedRowRender: (data_children) => {
                    // COLUNAS TABLE
                    const columns_children = [
                      {
                        dataIndex: "descricao",
                        title: "Competência",
                      },
                      {
                        dataIndex: "total_finalizados",
                        title: <CheckCircleOutlined style={{ fontSize: 16, color: "#60b565" }} />,
                        width: 50,
                      },
                      {
                        dataIndex: "total_pendentes",
                        title: <ClockCircleOutlined style={{ fontSize: 16, color: "red" }} />,
                        width: 50,
                      },
                      {
                        key: "acoes",
                        title: "Ações",
                        width: 50,
                        render: (_, e) => (
                          <Tooltip title="Definir Ações">
                            <Button
                              loading={loading}
                              onClick={() => navigate(`/pdi/acoes/${e.id}`)}
                              icon={<FormOutlined />}
                            />
                          </Tooltip>
                        ),
                      },
                    ];

                    return (
                      <Table
                        loading={loading}
                        columns={columns_children}
                        dataSource={data_children.competencias}
                        pagination={false}
                        size="small"
                        rowKey="id"
                      />
                    );
                  },
                  defaultExpandedRowKeys: ["0"],
                }}
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
